import React from "react";
import "./mini-sidebar.css";

function MiniSidebar({ visible, onOpenSidebar, onNewThread, onFocusSearch, onGoHome, onDiscover }) {
  if (!visible) return null;

  return (
    <div className="mini-sidebar">
      <button
        className="mini-sidebar-btn"
        onClick={onOpenSidebar}
        title="Open menu"
      >
        <i className="fa-solid fa-bars"></i>
      </button>
      <button
        className="mini-sidebar-btn"
        onClick={onGoHome}
        title="Home"
      >
        <i className="fa-solid fa-house"></i>
      </button>
      <button
        className="mini-sidebar-btn"
        onClick={onNewThread}
        title="New thread"
      >
        <i className="fa-solid fa-pen-to-square"></i>
      </button>
      <button
        className="mini-sidebar-btn"
        onClick={onFocusSearch}
        title="Search threads"
      >
        <i className="fa-solid fa-magnifying-glass"></i>
      </button>
      <button
        className="mini-sidebar-btn"
        onClick={onDiscover}
        title="Discover DeepMedIQ"
      >
        <i className="fa-solid fa-compass"></i>
      </button>
    </div>
  );
}

export default MiniSidebar;
